module.exports = __webpack_public_path__ + "img/lens-167-plus-03.efc728e5.png";